import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { LoginComponent } from "./login/login.component";
import { DirectAccessGuard } from "./direct-access-guard";
import { LayoutComponent } from "./layout/layout.component";
import { AuthService } from "./shared/services/auth.service";
import { CanDeactivateGuardService } from "./shared/services/can-deactivate-guard.service";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { ReportsComponent } from "./reports/reports.component";
import { SuppliesComponent } from "./supplies/supplies.component";
import { InboxViewComponent } from "./inbox/inbox-view/inbox-view.component";
import { InboxScreenComponent } from "./inbox/inbox-screen.component";
import { OrderSummaryComponent } from "./inbox/order-summary/order-summary.component";
import { MngComponent } from "./mng/mng.component";
import { MngClinicsComponent } from "./mng/mng-clinics/mng-clinics.component";
import { MngUsersComponent } from "./mng/mng-users/mng-users.component";
import { MngParamsComponent } from "./mng/mng-params/mng-params.component";
import { OperationReportsComponent } from "./operation-reports/operation-reports.component";
import { LabKpiComponent } from "./lab-kpi/lab-kpi.component";
import { KpiMainComponent } from "./lab-kpi/kpi-main/kpi-main.component";
import { KpiBroshComponent } from "./lab-kpi/kpi-brosh/kpi-brosh.component";
import { KpiClinicsComponent } from "./lab-kpi/kpi-clinics/kpi-clinics.component";
import { KpiAgentsComponent } from "./lab-kpi/kpi-agents/kpi-agents.component";
import { AgentTasksComponent } from "./agent-tasks/agent-tasks.component";
import { MngDrProfileComponent } from "./mng/mng-dr-profile/mng-dr-profile.component";
import { SummaryComponent } from "./inbox/order-summary/summary/summary.component";
import { RxFormComponent } from "./inbox/order-summary/rx-form/rx-form.component";
import { NoteCatalogComponent } from "./note-catalog/note-catalog.component";
import { DeliveryWb } from "./delivery-wb/delivery-wb";

const initialLang = new URL(location.href).searchParams.get("lang");
export const routes: Routes = [
  { path: "", redirectTo: "login", pathMatch: "full" },
  {
    path: "login",
    component: LoginComponent,
    data: { lang: initialLang, resetReuseStrategy: true },
  },
  {
    path: "main",
    component: LayoutComponent,
    data: {
      reuse: false,
    },
    canActivate: [AuthService],
    children: [
      {
        path: "",
        redirectTo: "dashboard",
        pathMatch: "full",
        //canActivate: [AuthService],
        data: {
          reuse: false,
        },
      },
      {
        path: "inbox",
        component: InboxScreenComponent,
        canActivate: [AuthService],
        canDeactivate: [CanDeactivateGuardService],
        children: [
          {
            path: "",
            redirectTo: "inbox-view",
            pathMatch: "full",
          },
          {
            path: "inbox-view",
            component: InboxViewComponent,
            data: {
              reuse: "inbox-view",
            },
          },
          {
            path: "order",
            component: OrderSummaryComponent,
            children: [
              {
                path: "",
                redirectTo: "summary",
                pathMatch: "full",
              },
              {
                path: "summary",
                component: SummaryComponent,
                data: {
                  reuse: "summary",
                },
              },
              {
                path: "rx",
                component: RxFormComponent,
                data: {
                  reuse: false,
                },
              },
              {
                path: "create-rx",
                component: RxFormComponent,
                data: {
                  reuse: false,
                },
              },
            ],
          },
        ],
      },
      {
        path: "dashboard",
        component: DashboardComponent,
        canActivate: [AuthService],
        canDeactivate: [CanDeactivateGuardService],
        data: {
          reuse: false,
        },
      },
      {
        path: "reports",
        component: ReportsComponent,
        canActivate: [AuthService],
        canDeactivate: [CanDeactivateGuardService],
        data: {
          reuse: "reports",
        },
      },
      // {
      //   path: "operation-reports",
      //   component: OperationReportsComponent,
      //   canActivate: [AuthService],
      //   canDeactivate: [CanDeactivateGuardService],
      //   data: {
      //     reuse: "operation-reports",
      //   },
      // },
      {
        path: "supplies",
        component: SuppliesComponent,
        canActivate: [AuthService],
        canDeactivate: [CanDeactivateGuardService],
        data: {
          reuse: "supplies",
        },
      },
      {
        path: "agent-tasks",
        component: AgentTasksComponent,
        canActivate: [AuthService],
        canDeactivate: [CanDeactivateGuardService],
        data: {
          reuse: false,
        },
      },
      {
        path: "notes-catalog",
        component: NoteCatalogComponent,
        canActivate: [AuthService],
        canDeactivate: [CanDeactivateGuardService],
        data: {
          reuse: true,
        },
      },
      {
        path: "mng",
        component: MngComponent,
        canActivate: [AuthService],
        canDeactivate: [CanDeactivateGuardService],
        children: [
          {
            path: "",
            redirectTo: "clinics",
            pathMatch: "full",
          },
          {
            path: "clinics",
            component: MngClinicsComponent,
            data: {
              reuse: "clinics",
            },
          },
          {
            path: "users",
            component: MngUsersComponent,
            data: {
              reuse: "users",
            },
          },
          {
            path: "dr-profile",
            component: MngDrProfileComponent,
            data: {
              reuse: "dr-profile",
            },
          },
          {
            path: "params",
            component: MngParamsComponent,
            data: {
              reuse: "params",
            },
          },
        ],
      },
      {
        path: "delivery-waybills",
        component: DeliveryWb,
        canActivate: [AuthService],
        canDeactivate: [CanDeactivateGuardService],
        data: {
          reuse: false,
        },
      },
      {
        path: "kpi",
        component: KpiMainComponent,
        canActivate: [AuthService],
        canDeactivate: [CanDeactivateGuardService],
        data: {
          reuse: false,
        },
        children: [

          {
            path: "brosh",
            component: KpiBroshComponent,
            data: {
              reuse: "brosh",
            },
          },
          {
            path: "kpi-clinics",
            component: KpiClinicsComponent,
            data: {
              reuse: "kpi-clinics",
            },
          },
          {
            path: "agents",
            component: KpiAgentsComponent,
            data: {
              reuse: "agents",
            },
          },
        ],
      },
    ],
  },
  { path: "**", redirectTo: "login" },
];

// @NgModule({
//   imports: [
//     RouterModule.forRoot(routes, {
//       onSameUrlNavigation: "reload",
//     }),
//   ],
//   exports: [RouterModule],
// })
// export class AppRoutingModule {}
